import { sharedDeliveryTermHeading } from './sharedDeliveryTerm';

export const orderDeliveryTermHeading = {
    ...sharedDeliveryTermHeading,
    hide: true,
};
